import lottie from "lottie-web";

// Lottieのアスペクト比を保ったまま親にフィット（opacity は触らない）
const resizeLottieToFit = (container, animation) => {
  const resizeHandler = () => {
    const parent = container.parentElement;
    if (!parent) return;

    const parentRect = parent.getBoundingClientRect();
    if (parentRect.width < 2 || parentRect.height < 2) {
      requestAnimationFrame(resizeHandler);
      return;
    }

    const animationData = animation.animationData;
    if (!animationData) return;

    const animationWidth = animationData.w;
    const animationHeight = animationData.h;

    container.style.width = `${animationWidth}px`;
    container.style.height = `${animationHeight}px`;

    const parentAspect = parentRect.width / parentRect.height;
    const animationAspect = animationWidth / animationHeight;

    let scale;
    if (parentAspect > animationAspect) {
      scale = parentRect.width / animationWidth;
    } else {
      scale = parentRect.height / animationHeight;
    }

    container.style.transform = `translate(-50%, -50%) scale(${scale})`;
  };

  resizeHandler();
  requestAnimationFrame(resizeHandler);
  window.addEventListener("resize", resizeHandler);
};

const SP_BREAKPOINT = 768;

const getResponsivePath = (container) => {
  const pathSp = container.dataset.lottiePathSp;
  const pathPc = container.dataset.lottiePath;
  if (pathSp && window.innerWidth < SP_BREAKPOINT) {
    return pathSp;
  }
  return pathPc;
};

export const lottieAnimation = () => {
  const containers = document.querySelectorAll(".js-lottie-container");

  containers.forEach((container) => {
    const pathPc = container.dataset.lottiePath;
    const pathSp = container.dataset.lottiePathSp;
    const loop = container.dataset.lottieLoop !== "false";
    const autoplay = container.dataset.lottieAutoplay !== "false";
    const renderer = container.dataset.lottieRenderer || "svg";

    if (!pathPc) return;

    let currentPath = getResponsivePath(container);
    let animation = null;

    const loadAnimation = (path) => {
      if (animation) {
        animation.destroy();
        container.classList.remove("lottie-loaded", "lottie-complete", "is-mv-lottie-visible");
      }

      animation = lottie.loadAnimation({
        container: container,
        renderer: renderer,
        loop: loop,
        autoplay: autoplay,
        path: path,
      });

      animation.addEventListener("DOMLoaded", () => {
        container.classList.add("lottie-loaded");

        if (container.classList.contains("js-mv-animation")) {
          resizeLottieToFit(container, animation);
          container.classList.add("is-mv-lottie-visible");

          let played = false;
          const playOnce = () => {
            if (played) return;
            played = true;
            animation.play();
          };

          const onTransitionEnd = (e) => {
            if (e.propertyName !== "opacity") return;
            container.removeEventListener("transitionend", onTransitionEnd);
            playOnce();
          };
          container.addEventListener("transitionend", onTransitionEnd);
          // CSS: delay 0.5s + fade 0.5s を想定したフォールバック
          setTimeout(playOnce, 1100);
          return;
        }
      });

      animation.addEventListener("complete", () => {
        container.classList.add("lottie-complete");
      });
    };

    loadAnimation(currentPath);

    // SP/PC切り替え時にアニメーションを再読み込み
    if (pathSp) {
      window.addEventListener("resize", () => {
        const newPath = getResponsivePath(container);
        if (newPath !== currentPath) {
          currentPath = newPath;
          loadAnimation(currentPath);
        }
      });
    }
  });
};
